import BillableItems from 'features/Invoice/BillableItems'
import CustomChargeBillableItems from 'features/Invoice/BillableItems/CustomChargeBillableItems'
import InvoiceInstructions from 'features/Invoice/InvoiceInstructions'
import InvoiceSummaryCard from 'features/Invoice/InvoiceSummaryCard'
import MessagesTable from 'features/Invoice/MessagesTable'
import TotalCard from 'features/Invoice/TotalCard'

import styles from './Invoice.module.scss'
import InvoiceHeader from './InvoiceHeader'
import RevisionLink from './RevisionLink'

const SingleInvoice = ({
  invoiceDetails,
  taxRate = 9.5,
  messagesWithAdditionalCharges
}) => {
  const { paymentPeriod, customCharges } = invoiceDetails

  const isLegacyInvoice =
    invoiceDetails.subsidiarySubscriptions?.length > 0 &&
    !invoiceDetails.subsidiarySubscriptions.some(sub => sub.plan === 'DirectfulCore')

  return (
    <div className={styles.invoice} id="invoice">
      <div className={styles.pageOne}>
        <InvoiceHeader paymentPeriod={paymentPeriod} />
        <InvoiceSummaryCard invoiceDetails={invoiceDetails} />
        <InvoiceInstructions invoiceDetails={invoiceDetails} />
        {customCharges?.length > 0 ? (
          <CustomChargeBillableItems customCharges={customCharges} />
        ) : (
          <BillableItems
            invoiceDetails={invoiceDetails}
            isLegacyInvoice={isLegacyInvoice}
          />
        )}
        <TotalCard
          invoiceDetails={invoiceDetails}
          taxRate={taxRate}
          isLegacyInvoice={isLegacyInvoice}
        />
        <RevisionLink invoiceDetails={invoiceDetails}></RevisionLink>
      </div>
      {messagesWithAdditionalCharges?.details?.length > 0 && (
        <div className={styles.paymentDetails}>
          <h3 className={styles.freeTitle}>Billable messages</h3>
          <MessagesTable
            promotionTextsCost={invoiceDetails.usedCustomMessageCreditAmount}
            promotionTextsCount={invoiceDetails.usedCustomMessageCreditCount}
            totalAfterPromotion={messagesWithAdditionalCharges.totalAfterPromotion}
            items={messagesWithAdditionalCharges.details}
          />
        </div>
      )}
    </div>
  )
}

export default SingleInvoice
